import { render, staticRenderFns } from "./OfferOutOfDate.vue?vue&type=template&id=0ffc58d8"
import script from "./OfferOutOfDate.vue?vue&type=script&lang=js"
export * from "./OfferOutOfDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports